
import React from 'react'
import { Search, X } from 'lucide-react'
import { Z_INDEX } from '@/lib/constants/z-index'

interface MobileSearchOverlayProps {
  isOpen: boolean
  onClose: () => void
}

export default function MobileSearchOverlay({ isOpen, onClose }: MobileSearchOverlayProps) {
  if (!isOpen) return null

  return (
    <div
      className="modal-overlay md:hidden"
      style={{ zIndex: Z_INDEX.MODAL }}
    >
      <div className="bg-brand-dark-light/95 backdrop-blur-sm p-4 border-b border-gray-700/50 animate-fade-in">
        <div className="flex items-center space-x-3">
          <div className="flex-1 relative group">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-brand-primary transition-colors duration-200 pointer-events-none z-10" size={20} />
            <input
              type="text"
              placeholder="Buscar colaboradores, documentos..."
              className="form-input pl-10 pr-4 py-3 text-sm w-full"
              style={{ paddingLeft: '3rem' }}
              autoFocus
            />
          </div>
          <button
            onClick={onClose}
            className="btn-icon text-gray-400 hover:text-white"
          >
            <X size={24} />
          </button>
        </div>
      </div>
    </div>
  )
}